import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Organization, AsyncStatus } from '@algoan/dashboard/model';

export type OrganizationErrorMessages = 'genericError';

export interface OrganizationReducerState {
  organization: Organization | undefined;
  organizationFetchingStatus: AsyncStatus;
  organizationError: OrganizationErrorMessages | undefined;
}

const getInitialState = (): OrganizationReducerState => ({
  organization: undefined,
  organizationFetchingStatus: AsyncStatus.IDLE,
  organizationError: undefined,
});

const initialState = getInitialState();

const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    resetOrganizationState: () => initialState,
    fetchOrganizationStart(state) {
      state.organizationFetchingStatus = AsyncStatus.PENDING;
      state.organizationError = undefined;
    },
    fetchOrganizationSuccess(state, action: PayloadAction<Organization>) {
      state.organization = action.payload;
      state.organizationFetchingStatus = AsyncStatus.RESOLVED;
      state.organizationError = undefined;
    },
    fetchOrganizationFailure(state, action: PayloadAction<{ error: OrganizationErrorMessages }>) {
      state.organizationFetchingStatus = AsyncStatus.REJECTED;
      state.organizationError = action.payload.error;
    },
  },
});

export const { reducer: organizationReducer } = organizationSlice;

export const { resetOrganizationState, fetchOrganizationStart, fetchOrganizationSuccess, fetchOrganizationFailure } =
  organizationSlice.actions;
